import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import i18n from '../i18n';
import { retrieveStorageById, patchStorage } from '../helpers/storeService';
import { useParams } from 'react-router';
import useRouting from '../hooks/useRouting';
import { ChatContext } from '../contexts/ChatContext';
import FlowChatBox from '../components/FlowChatBox';
import { getNestedObject } from '../helpers/objectService';

const FlowVehiclePurposeMobile = () => {
  const { id, affinity, insuranceType, currentVehicle } = useParams();
  const { renderNextRoute } = useRouting();
  const { data } = retrieveStorageById(id, affinity, insuranceType) || {};
  const { addQuestion, addAnswer } = useContext(ChatContext);
  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    const question = {
      message: i18n.t(
        'Do you use the vehicle for <span>professional use</span>?'
      ),
      slug: 'vehicle_used_professionally',
    };
    addQuestion(question);
    loadDefaultValues();
  }, []);

  const loadDefaultValues = async () => {
    const defaultValuesTemp = {
      vehicle_used_professionally: getNestedObject(data, [
        'cars',
        [currentVehicle],
        'vehicle_used_professionally',
      ]),
    };
    setDefaultValues(defaultValuesTemp);
  };

  const submitHandler = () => {
    let car_information = {
      vehicle_used_professionally: defaultValues.vehicle_used_professionally,
    };
    patchStorage({
      payload: car_information,
      path: ['cars', [currentVehicle]],
      id,
      affinity,
      insuranceType,
    });

    const answer = {
      message: defaultValues.vehicle_used_professionally
        ? i18n.t('Yes, the car is used <span>professionally</span>')
        : i18n.t('No, the car is for <span>private use</span>'),
      slug: 'vehicle_used_professionally',
    };
    addAnswer(answer);

    renderNextRoute(1, { vehicle: currentVehicle });
  };

  return (
    <Container>
      <FlowChatBox />
      <RightContainer>
        <AddressToInsureQ>
          <StyledButton
            active={defaultValues.vehicle_used_professionally}
            onClick={() => {
              defaultValues.vehicle_used_professionally = true;
              submitHandler();
            }}
          >
            {i18n.t('Yes')}
          </StyledButton>
          <StyledButton
            active={!defaultValues?.vehicle_used_professionally}
            onClick={() => {
              defaultValues.vehicle_used_professionally = false;
              submitHandler();
            }}
          >
            {i18n.t('No')}
          </StyledButton>
        </AddressToInsureQ>
      </RightContainer>
    </Container>
  );
};

const AddressToInsureQ = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 45% 45%;
  width: 100%;
  justify-content: center;
`;

const StyledButton = styled.button`
  background-color: ${({ active, theme }) =>
    active ? theme.brand.primary : '#ffffff'};
  border: ${({ active, theme }) =>
    active ? 'none' : `2px solid ${theme.brand.primary}`};
  border-radius: 5px;
  color: ${({ active, theme }) => (active ? '#ffffff' : theme.brand.primary)};
  cursor: pointer;
  font-weight: bold;
  font-size: 1.4rem;
  height: 4rem;
  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.brand.light};
    color: white;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: 85% 15%;
  width: 100%;
  overflow: hidden;
`;

const RightContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 2rem;
`;

export default FlowVehiclePurposeMobile;
